var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 60px - 160px)"},attrs:{"src":_vm.playUrl,"frameborder":"0","id":"activity"}})
}
var staticRenderFns = []

export { render, staticRenderFns }